import { Module } from "vuex";
import { RootState } from "../types";
import { JobStagesInt } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as JobStagesInt;

export const jobStages: Module<JobStagesInt, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
